import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GenericModal from "./GenericModal";
import ModalReferralstwo from "./ModalReferralstwo";
import { fetchReferralsItems } from "./redux/slices/ReferralsThunks";
import ReferralCard from "./ReferralCard";
import { resetUpdateSuccess } from "./redux/slices/ReferralsSlice";

export default function Referrals() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const referrals = useSelector((state) => state.referrals.items);

  const referralsLoading = useSelector((state) => state.referrals.loading);
  const vendor = JSON.parse(localStorage.getItem("vendor"));
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");
  const [selectedReferral, setSelectedReferral] = useState(null);
  const [enrichedReferrals, setEnrichedReferrals] = useState([]);
  const updateSuccess = useSelector((state) => state.referrals.updateSuccess);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEditClick = (referral) => {
    setSelectedReferral(referral);
    openModal();
  };

  const tableHeaders = [
    { label: "Referral ID", flex: true },
    { label: "Referrer Name", flex: true },
    { label: "Potential Client's Website", width: "20%" },
    { label: "Expected/Actual Close Date", width: "25%"  },
    { label: "Status", flex: true, type: "status" },
    { label: "Action", flex: true, align: "center" },
  ];

  const tableColumns = [
    { key: "referrer_id", flex: true },
    { key: "memberName", flex: true },
    { key: "company_website_url", width: "20%" },
    { key: "expected_close_date", width: "25%" },
    { key: "referral_status", flex: true, type: "status" },
    { key: "action", flex: true, align: "center" },
  ];

  const downloadCSV = (columns, headers, data, filename = "referrals.csv") => {
    const csvHeaders = columns.map((col, index) => headers[index].label);
    const csvRows = data.map((row) =>
      columns.map((col) => `"${row[col.key] ?? ""}"`).join(",")
    );

    const csvString = [csvHeaders.join(","), ...csvRows].join("\n");

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (!referrals.length) return;

    const enriched = referrals.map((ref) => ({
      ...ref,
      memberName: `${ref.member_id.first_name} ${ref.member_id.last_name}`,
      referrer_id: "R" + ref._id.slice(-7),
    }));

    setEnrichedReferrals(enriched);
  }, [referrals]);

  const filteredReferrals = useMemo(() => {
    let filtered = [...enrichedReferrals];

    const searchableKeys = [
      "referrer_id",
      "memberName",
      "company_website_url",
      "expected_close_date",
      "referral_status",
    ];

    if (searchTerm.trim()) {
      const terms = searchTerm.toLowerCase().split(/\s+/);

      filtered = filtered.filter((item) => {
        let termIndex = 0;

        for (
          let i = 0;
          i < searchableKeys.length && termIndex < terms.length;
          i++
        ) {
          const value = item[searchableKeys[i]]?.toLowerCase() || "";
          if (value.includes(terms[termIndex])) {
            termIndex++;
          }
        }

        return termIndex === terms.length;
      });
    }
    // Apply filter
    if (filterType === "latest") {
      filtered = filtered.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    } else if (filterType === "oldest") {
      filtered = filtered.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );
    } else if (filterType === "Won") {
      filtered = filtered.filter((item) => item.referral_status === "Won");
    } else if (filterType === "Lost") {
      filtered = filtered.filter((item) => item.referral_status === "Lost");
    } else if (filterType === "Lead Identified") {
      filtered = filtered.filter(
        (item) => item.referral_status === "Lead Identified"
      );
    } else if (filterType === "Opportunity") {
      filtered = filtered.filter(
        (item) => item.referral_status === "Opportunity"
      );
    }

    // Sort by expected_close_date (soonest first)
    filtered.sort((a, b) => {
      const dateA = new Date(a.expected_close_date);
      const dateB = new Date(b.expected_close_date);
      return dateA - dateB; // ascending
    });

    return filtered;
  }, [enrichedReferrals, searchTerm, filterType]);

  useEffect(() => {
    dispatch(fetchReferralsItems(vendor?._id));
  }, []);

  useEffect(() => {
    if (updateSuccess && vendor?._id) {
      dispatch(fetchReferralsItems(vendor._id));
      dispatch(resetUpdateSuccess());
    }
  }, [updateSuccess, vendor?._id, dispatch]);
  const isLoading = referralsLoading;
  return (
    <RootWrapperReferralsone>
      <Dashboard>
        <Wrapper>
          <DashboardHeader>
            <Frame1462>
              <WelcomeJames>Referrals</WelcomeJames>
            </Frame1462>
            <Frame1461>
              <PRTNR.Button
                variant="black"
                onClick={() =>
                  downloadCSV(tableColumns, tableHeaders, filteredReferrals)
                }
              >
                Download
              </PRTNR.Button>
            </Frame1461>
          </DashboardHeader>
          <DashboardData>
            <Left_0001>
              <CardWrapper>
                <Frame1433>
                  <Frame1431>
                    <RecentReferrals>Referrals</RecentReferrals>
                  </Frame1431>
                  <Frame1432>
                    <GFieldsStacked>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Select
                        type="text"
                        placeholder="Filter by:"
                        options={[
                          {
                            label: "Lead Identified",
                            value: "Lead Identified",
                          },
                          { label: "Opportunity", value: "Opportunity" },
                          { label: "Won", value: "Won" },
                          { label: "Lost", value: "Lost" },
                        ]}
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </Frame1432>
                </Frame1433>

                {filteredReferrals.map((item, index) => (
                  <ReferralCard
                    key={index}
                    item={item}
                    handleEditClick={handleEditClick}
                  />
                ))}
              </CardWrapper>
              <TableReferrals>
                <Frame1433>
                  <Frame1431>
                    <RecentReferrals>Referrals</RecentReferrals>
                  </Frame1431>
                  <Frame1432>
                    <GFieldsStacked>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Select
                        type="text"
                        placeholder="Filter by:"
                        options={[
                          {
                            label: "Lead Identified",
                            value: "Lead Identified",
                          },
                          { label: "Opportunity", value: "Opportunity" },
                          { label: "Won", value: "Won" },
                          { label: "Lost", value: "Lost" },
                        ]}
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </Frame1432>
                </Frame1433>
                <ScrollContainer>
                  <PRTNR.TableComponent
                    data={filteredReferrals}
                    tableColumns={tableColumns}
                    tableHeaders={tableHeaders}
                    handleEditClick={handleEditClick}
                    isLoading={isLoading}
                  />
                </ScrollContainer>
              </TableReferrals>
            </Left_0001>
          </DashboardData>
        </Wrapper>
      </Dashboard>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalReferralstwo
          isOpen={isModalOpen}
          onClose={closeModal}
          referral={selectedReferral}
        />
      </GenericModal>
    </RootWrapperReferralsone>
  );
}

const RootWrapperReferralsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  flex-shrink: 0;
  flex: 1;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0px 0px 32px;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 32px 0px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1043px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(1.5rem, 5vw, 3rem);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const DashboardData = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
const CardWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex; /* Show cards only on mobile */
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }
`;
const Left_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
`;
const ScrollContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`;

const TableReferrals = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
  @media (max-width: 768px) {
    display: none;
  }
`;

const Frame1433 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 763px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const RecentReferrals = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  flex: 1;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
  width: 220px;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
  width: 180px;
`;
